import { render, staticRenderFns } from "./SumupTransactionV2.vue?vue&type=template&id=a89e9704&scoped=true&"
import script from "./SumupTransactionV2.vue?vue&type=script&lang=js&"
export * from "./SumupTransactionV2.vue?vue&type=script&lang=js&"
import style0 from "./SumupTransactionV2.vue?vue&type=style&index=0&id=a89e9704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89e9704",
  null
  
)

export default component.exports